import { h, Component } from 'preact';
import Util from '../../services/util';

class BackgroundContainer extends Component {
    constructor() {
        super();
        this.state = {
            isNativeClient: Util.isNativeClient()
        };
    }

    render({backgroundImageUrl}, {}) {
        return(
            <div>
            {this.state.isNativeClient ? (
                   <div className='background-container native-client'/>
                ) : (
                   <div className='background-container' style={{backgroundImage: `url(${backgroundImageUrl})`}}/>
                )
            }
            </div>
        )
    }
}

export default BackgroundContainer;



// WEBPACK FOOTER //
// ./src/scripts/views/tags/background-container.js